import axios from 'axios';
import { POSTALCODE_API_BASE_URL } from '../../src/const/Const';

export const getPrefecture = () => {
  return axios
    .get(`/api/get/prefectures`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getHousing = () => {
  return axios
    .get(`/api/get/housings`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getMediation = () => {
  return axios
    .get(`/api/get/mediations`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getIndustries = () => {
  return axios
    .get(`/api/get/industries`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getEndOfDay = () => {
  return axios
    .get(`/api/get/closing/dates`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const fetchAddressFromPostalCode = async (postalCode: any) => {
  try {
    // 入力を文字列に変換し、前後の空白を除去
    let normalizedPostalCode = postalCode.toString().trim();

    // 全角数字を半角数字に変換
    normalizedPostalCode = normalizedPostalCode.replace(/[０-９]/g, (s: any) =>
      String.fromCharCode(s.charCodeAt(0) - 0xfee0)
    );

    // 全角ハイフンや特殊なハイフンを半角ハイフンに変換
    normalizedPostalCode = normalizedPostalCode.replace(/[−—–‐－]/g, '-');

    // ハイフンをすべて除去
    normalizedPostalCode = normalizedPostalCode.replace(/-/g, '');

    // 数字のみで構成されているか確認
    if (!/^\d+$/.test(normalizedPostalCode)) {
      throw new Error('郵便番号は数字で入力してください。');
    }

    // 桁数が7桁であるか確認
    if (normalizedPostalCode.length !== 7) {
      throw new Error('郵便番号は7桁で入力してください。');
    }

    // APIリクエストを実行
    const response = await axios.get(
      `${POSTALCODE_API_BASE_URL}/postcodes/${normalizedPostalCode}.json`
    );
    const data = response.data;

    if (data && data.prefecture && data.city && data.suburb) {
      return { success: true, data: data };
    } else {
      return { success: false, message: '住所が見つかりませんでした。' };
    }
  } catch (err: any) {
    return {
      success: false,
      message:
        err.message ||
        'システムエラーが発生しました。住所は手動で入力してください。'
    };
  }
};

export const getDepositeSite = () => {
  return axios
    .get(`/api/get/deposit/sites`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getRank = () => {
  return axios
    .get(`/api/get/ranks`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const saveCustomer = (
  name: string,
  furigana: string,
  postal_code: string,
  client_type: number | undefined,
  prefecture: number | undefined,
  muncipality: string,
  address: string,
  building_name: string,
  tel: number,
  fax: number,
  charge_name: string,
  charge_tel: number | string,
  charge_email: string,
  in_charge1: number,
  in_charge2: number,
  housing: number | undefined,
  mediation: number | undefined,
  industry: number | undefined,
  end_day: number | undefined,
  deposit_site_month: string,
  deposit_site_date: string,
  rank: number | undefined,
  remarks: string
) => {
  return axios
    .post(
      `/api/create/customer`,
      {
        name,
        furigana,
        postal_code,
        client_type,
        prefecture,
        muncipality,
        address,
        building_name,
        tel,
        fax,
        charge_name,
        charge_tel,
        charge_email,
        in_charge1,
        in_charge2,
        housing,
        mediation,
        industry,
        end_day,
        deposit_site_month,
        deposit_site_date,
        rank,
        remarks
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getCustomerDetails = (id: number) => {
  return axios
    .get(`/api/get/customer/details/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      console.log('customer details', response);
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const editCustomer = (
  customer_id: number,
  name: string,
  furigana: string,
  postal_code: string,
  client_type: number | undefined,
  prefecture: number | undefined,
  muncipality: string,
  address: string,
  building_name: string,
  tel: number,
  fax: number,
  charge_name: string,
  charge_tel: number | string,
  charge_email: string,
  in_charge1: number,
  in_charge2: number,
  housing: number | undefined,
  mediation: number | undefined,
  industry: number | undefined,
  end_day: number | undefined,
  deposit_site_month: string,
  deposit_site_date: string,
  rank: number | undefined,
  remarks: string
) => {
  return axios
    .put(
      `/api/update/customer/details/${customer_id}`,
      {
        name,
        furigana,
        postal_code,
        client_type,
        prefecture,
        muncipality,
        address,
        building_name,
        tel,
        fax,
        charge_name,
        charge_tel,
        charge_email,
        in_charge1,
        in_charge2,
        housing,
        mediation,
        industry,
        end_day,
        deposit_site_month,
        deposit_site_date,
        rank,
        remarks
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      console.log('edit response', response);
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const saveContactUs = (
  client_id: number | undefined,
  content: string,
  property: string,
  location: string,
  desired_real_estate_content: string,
  desired_date_of_delivery: string,
  budget: number
) => {
  return axios
    .post(
      `/api/v1/client/enquiry`,
      {
        client_id,
        content,
        property,
        location,
        desired_real_estate_content,
        desired_date_of_delivery,
        budget
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getContactUsHistory = (id: number) => {
  return axios
    .get(`/api/v1/client/enquiry/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const deleteContactUsHistory = (id: number) => {
  return axios
    .delete(`/api/v1/client/enquiry/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const deleteCustomerById = (id: number) => {
  return axios
    .delete(`/api/delete/customer/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const sendMail = ({
  historyId,
  groupId
}: {
  historyId: number;
  groupId: number;
}) => {
  return axios
    .post(
      `/api/v1/email/client/enquiry/${historyId}`,
      {
        group_id: groupId
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getPartnerDetails = (id: number) => {
  return axios
    .get(`/api/v1/get/partner?partner_id=${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      console.log('customer details', response);
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
